import { applyCalendarDates, mergeResumeDraft, seedTypicalWork, type ResumeDraft } from "@reactive-resume/schema";

import { processAi } from "@/client/services/ai";

type Identity = { name?: string; email?: string; location?: string };

export type ExtractedDraft = { draft: ResumeDraft; callId?: string };

export const extractDraftFromNotes = async (
  text: string,
  identity: Identity,
  enrich: boolean,
  base: ResumeDraft = {},
): Promise<ExtractedDraft | null> => {
  const trimmed = text.trim();
  if (!trimmed) return null;

  try {
    const response = await processAi({
      action: "draft-from-text",
      content: trimmed.slice(0, 12_000),
      context: { name: identity.name, email: identity.email, enrich },
    });

    const extracted = response.metadata?.draft as ResumeDraft | undefined;
    const blocked = Boolean(response.rateLimit?.blocked || response.metadata?.parseError);
    if (blocked || !extracted || typeof extracted !== "object") return null;

    const merged = mergeResumeDraft(
      {
        ...base,
        basics: {
          name: identity.name,
          email: identity.email,
          ...base.basics,
          ...(identity.location?.trim() ? { location: identity.location.trim() } : {}),
        },
      },
      extracted,
    );

    return {
      draft: enrich ? seedTypicalWork(merged) : applyCalendarDates(merged),
      callId: response.callId,
    };
  } catch {
    return null;
  }
};
